module.exports = __webpack_public_path__ + "img/260w.71efffa.jpg";